export const STATSIG_STATE_PROP_NAME = "__STATSIG_STATE__";
